import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import NotFoundPage from 'router/subrouters/Dash/pages/NotFoundPage';
import RwcAnalyticsLayout from './components/RwcAnalyticsLayout';
import RwcSuggestedActions from './components/RwcSuggestedActions';
import Configuration from '../Configuration';
import Branding from '../Branding';

const rwcEnterpriseRoutes = [
  {
    path: 'suggested-actions',
    element: RwcSuggestedActions,
  },
  {
    path: 'configuration',
    element: Configuration,
  },
  {
    path: 'branding',
    element: Branding,
  },
  { index: true, element: RwcAnalyticsLayout },
  { path: '*', element: NotFoundPage },
] as Array<EnhancedRouteProps>;

export default rwcEnterpriseRoutes;
